




























































































































































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import DropdownSystem from '@/shared/dropdown/dropdown.component.vue';
import SearchBar from '@/shared/search/search.component.vue';
import ButtonRequest from '@/shared/button/button.component.vue';
import ButtonDropdown from '@/shared/button/button-dropdown.component.vue';
import WorkItemsList from '@/views/work-item/work-item-list.component.vue';
import WorkItemEntity from '@/domain/work-item/work-item.entity';
import ModalConfirm from '@/shared/modals/modal-confirm.component.vue';
import WorkItemService from '@/domain/work-item/work-item.service';
import FilterPanel from '@/views/work-item/work-item-filter.component.vue';
import OptionColumn from '@/views/work-item/work-item-option-list.modal.vue';
import ProjectsDetail from '@/domain/project/project-detail.entity';
import Project from '@/domain/project/project.entity';
import ProjectUserStore from '@/domain/project/project-with-members.store';
import ProjectSearchService from '@/domain/project/project-search.service';
import UserService from '@/domain/user/user.service';
import Header from '@/views/work-item/header.json';
import WorkItemOptionListService from '@/views/work-item/work-item-option-list.service';
import WorkItemModal from '@/views/work-item/work-item-modal.component.vue';
import WorkItemModalExport from '@/views/work-item/work-item-modal-export.component.vue';
import workItemModalReprocess from '@/views/work-item/work-item-modal-reprocess.component.vue';
import WorkItemFilter from '@/domain/work-item/work-item-filter.entity';
import StringMatch from '@/shared/utils/string-match';
import WorkItemFilterService from '@/domain/work-item/work-item-filter.service';
import DirectivesService from '@/domain/directives/directives.service';
import FilterFields from '@/domain/project/filter-fields.entity';
import WorkItemModalState from '@/domain/work-item/work-item-modal-state.entity';
import WorkItemModalActions from '@/views/work-item/work-item-modal-actions.enum';
import WorkItemDefinitionType from '@/views/work-item/work-item-definition-type.enum';
import WorkItemPostTask from '@/domain/work-item/work-item-post-task.entity';
import WorkItemPostAggregator from '@/domain/work-item/work-item-post-aggregator.entity';
import WorkItemSummary from '@/domain/work-item/work-item-summary.entity';
import QueryParamsSubtractor from '../../shared/utils/query-params-subtractor';
import WorkItemRelated from '@/domain/work-item/work-item-related.entity';
import PaginationDisplay from '@/shared/pagination/pagination-display.component.vue';

Component.registerHooks(['beforeRouteUpdate']);
@Component({
  components: {
    DropdownSystem,
    SearchBar,
    ButtonRequest,
    ButtonDropdown,
    WorkItemsList,
    OptionColumn,
    ModalConfirm,
    WorkItemModal,
    WorkItemModalExport,
    workItemModalReprocess,
    FilterPanel,
    PaginationDisplay,
  },
})
export default class WorkItem extends Vue {
  private mapperWorkItemTypes: string[] = [];

  private projectIdMapper: string = '';

  private workItems: WorkItemSummary[] = [];

  private parentWorkItems: any[] = [];

  private workItemForDeletion: string = '';

  private workItemForClose: string = '';

  private workItemTaskForClose: string = '';

  private workItemFilter: WorkItemFilter = new WorkItemFilter();

  private selectedMember: string = '';

  private loading: boolean = false;

  private project!: Project;

  private projectsStore = getModule(ProjectUserStore);

  private projectDetail = new ProjectsDetail();

  private headerOptions!: any[];

  private readonly headers: any[] = Header;

  private filterFields: FilterFields = new FilterFields();

  private createdDate: any = [new Date(), new Date()];

  private estimatedDate: any = [new Date(), new Date()];

  private dialog: boolean = false;

  private newDate: Date = new Date();

  private workItemSelected: any = new WorkItemEntity();

  private workItemTypeDefinition: any = Object.values(WorkItemDefinitionType);

  private workItemTypeSelected: any = '';

  private workItemAction: any = WorkItemModalActions;

  private saveWorkItemLoading: boolean = false;

  private autoFill: boolean = false;

  private projectDirectives: any[] = [];

  private modalFields: WorkItemModalState = new WorkItemModalState(
    WorkItemModalActions.VIEW, this.workItemTypeDefinition,
  );

  private totalWorkItems: number = 0;

  private query: string = '';

  private defaultQuery = {
    page: 0,
    size: 10,
    sort: 'createdDate,number,desc',
  };

  private page: number = 1;

  private size: number = 10;

  filterInput = '';

  modalExport: boolean = false;

  modalReprocess: boolean = false;

  selectedWorkItens: WorkItemSummary[] = [];

  filterType: string = '';

  firstFetched: boolean = false;

  created() {
    this.projectsStore.fetchProjects()
      .then(() => {
        WorkItemFilterService
          .getAllOriginSystems()
          .then(value => this.filterFields.originSystems = value);

        this.setProject(this.$route.params.projectName)
          .then(this.loadParentWorkItems);
      });
  }

  setProject(projectName: string) {
    return this.projectsStore
      .getProject(projectName)
      .then(project => (this.project = new Project(project)))
      .then(() => {
        this.updateFields();
        this.updateWorkItemList(this.project.id);
      });
  }

  updateWorkItemList(projectId: string) {
    ProjectSearchService
      .getOneProject(this.project.id)
      .then(value => (this.projectDetail = value));

    this.searchMembers(projectId);
    WorkItemOptionListService.getColumnSaved(this.headers);
  }

  beforeRouteUpdate(to: any, from: any, next: any) {
    if (to.path !== from.path) {
      this.query = '';
      this.page = 1;
    }
    this.setProject(to.params.projectName);
    next();
  }

  saveWorkItem(form: any) {
    this.saveWorkItemLoading = true;
    WorkItemService.saveWorkItem(this.project.id, form)
      .then((response: any) => {
        if (response && response.status === 200) {
          this.updateList();
          this.updateWorkItemList(this.project.id);

          this.updateChildrenList();

          this.closeModal();
        }
      }).catch((err: any) => console.log(err))
      .finally(() => this.saveWorkItemLoading = false);
  }

  updateChildrenList() {
    const workItemsList = this.$refs.workItemsList as any;
    if (workItemsList && workItemsList.expandedWorkItemId) {
      workItemsList.loadChildren(workItemsList.expandedWorkItemId);
    }
  }

  updateFields() {
    WorkItemFilterService.getAllActiveStatus()
      .then(status => this.filterFields.workItemStatus = status);

    WorkItemFilterService.getAllWorkItemTypes()
      .then(types => this.filterFields.workItemTypes = types);

    WorkItemFilterService.getProjectCoreIdMapper(this.project.id)
      .then((types: any) => {
        let exemplo: string = '';
        for (let index = 0; index < types.length; index += 1) {
          const element = types[index];
          if (element.integration.id === '4605faee-56d4-40df-b807-20a18582d4a0') {
            exemplo = element.id;
          }
        }
        this.projectIdMapper = exemplo;
      })
      .catch((err: any) => console.log(err))
      .finally(() => {
        this.setWorkItemTypesMapper(this.project.id);
      });

    UserService.searchAllUsersByProject(this.project.id)
      .then(users => this.filterFields.members = users);

    DirectivesService.getProjectDirectives(this.project.id)
      .then((directives: any) => this.projectDirectives = directives || []);
  }

  private setWorkItemTypesMapper(projectid: string) {
    WorkItemFilterService.getProjectDirectivesMapper(this.projectIdMapper)
      .then((types: any) => {
        const exemplo: string[] = [];
        for (let index = 0; index < types.rules.length; index += 1) {
          const element = types.rules[index];
          if (element.filters[0].fieldName === 'WorkItemType') {
            exemplo.push(element.filters[0].value);
          }
        }
        this.filterFields.workItemTypesMapper = exemplo;
      })
      .catch((err: any) => console.log(err));
  }

  private updateQuery(obj: any) {
    this.page = (Number(obj.page)) + 1;
    this.size = Number(obj.size);
    this.query = QueryParamsSubtractor.fromObjectToString(obj);
    this.updateList();
  }

  private updateRouter() {
    this.$router.push(this.query);
  }

  private get computedQuery() {
    if (!(this.query !== '')) {
      this.query = QueryParamsSubtractor.fromObjectToString(this.defaultQuery);
    }
    return this.query;
  }

  private paginationChanged(query: any = this.defaultQuery) {
    this.updateQuery(query);
  }

  handleUpdateFilterType(filterType: string) {
    if (!filterType) {
      return;
    }
    this.filterType = filterType;
    this.workItemFilter.workItemFilterType = filterType;
  }

  setFilterFields() {
    if (this.filterType === 'AGGREGATOR') {
      this.workItemFilter.aggregatorsAndOrphanTasks = true;
      this.workItemFilter.filterChildren = false;
      this.workItemFilter.onlyChildren = false;
      return;
    }
    if (this.filterType === 'TASK') {
      this.workItemFilter.aggregatorsAndOrphanTasks = true;
      this.workItemFilter.filterChildren = false;
      this.workItemFilter.onlyChildren = true;
      return;
    }
    this.workItemFilter.aggregatorsAndOrphanTasks = true;
    this.workItemFilter.filterChildren = true;
    this.workItemFilter.onlyChildren = false;
  }

  loadParentWorkItems() {
    this.parentWorkItems = [];
    WorkItemService
      .searchParentWorkItemsByProject(this.project.id)
      .then(parentWorkItems => this.parentWorkItems = parentWorkItems);
  }

  updateList() {
    this.loading = true;
    this.workItemFilter.formatAllFields();
    this.workItemFilter.member = this.selectedMember;
    this.workItems = [];
    const query = this.computedQuery;
    this.loadParentWorkItems();
    WorkItemService
      .searchAllWorkItemsBySelectMember(this.project.id,
        this.workItemFilter,
        this.selectedMember, query)
      .then((response: any) => {
        this.firstFetched = true;
        this.collapseRows();
        this.totalWorkItems = response.totalElements;
        this.updateRouter();
        this.workItems = WorkItemSummary.ofList(response.content);
        this.workItems.forEach((it: WorkItemSummary) => {
          const isVsts = it.originSystem === 'VSTS';
          if (isVsts) {
            this.getWorkItemErrorsByTitle(it);
            return;
          }
          this.getWorkItemErrorsById(it);
        });
      })
      .finally(() => (this.loading = false));
  }

  collapseRows() {
    const { workItemsList }: any = this.$refs;
    workItemsList.collapseRows();
  }

  getWorkItemErrorsByTitle(workItem: WorkItemSummary) {
    WorkItemService.getWorkItemErrorsByTitle(this.project.id, workItem.title)
      .then(({ data }: any) => {
        workItem.error = data.error;
      }).catch(() => { });
  }

  getWorkItemErrorsById(workItem: WorkItemSummary) {
    WorkItemService.getWorkItemErrors(this.project.id, workItem.id)
      .then(({ data }: any) => {
        workItem.error = data.error;
      }).catch(() => { });
  }

  newWorkItem() {
    const object = {
      project: {
        id: this.project.id,
        name: this.$route.params.projectName,
      },
      createdDate: this.newDate.toISOString().split('T')[0],
      status: 'OPEN',
      children: [],
    };

    const workItem = this.workItemTypeSelected === 'TASK'
      ? WorkItemPostTask.of(object)
      : WorkItemPostAggregator.of(object);

    this.autoFill = false;
    this.showModal(workItem, WorkItemModalActions.CREATE, this.workItemTypeSelected);
  }

  askDeletionConfirmation(workItemId: string) {
    this.workItemForDeletion = workItemId;
  }

  askCloseConfirmation(workItemId: string) {
    this.workItemForClose = workItemId;
  }

  askCloseTaskConfirmation(workItemId: string) {
    this.workItemTaskForClose = workItemId;
  }

  deleteWorkItem(workItemId: string) {
    WorkItemService.deleteWorkitem(this.project.id, workItemId)
      .then(() => this.updateList())
      .then(() => (this.workItemForDeletion = ''))
      .then(() => this.updateWorkItemList(this.project.id))
      .then(() => this.updateChildrenList());
  }

  closeWorkItem(workItemId: string) {
    WorkItemService.getOneWorkItemById(this.project.id, workItemId)
      .then((workItem: any) => {
        this.workItemSelected = workItem;
        return WorkItemService.closeWorkitem(this.project.id, workItemId, this.workItemSelected);
      })
      .then(() => this.updateList())
      .then(() => (this.workItemForClose = ''))
      .then(() => this.updateWorkItemList(this.project.id))
      .then(() => this.updateChildrenList())
      .catch((error: any) => {
        console.error('Error closing work item:', error);
      });
  }

  closeTaskWorkItem(workItemId: string) {
    WorkItemService.getOneWorkItemById(this.project.id, workItemId)
      .then((workItem: any) => {
        this.workItemSelected = workItem;
        return WorkItemService.closeWorkitem(this.project.id, workItemId, this.workItemSelected);
      })
      .then(() => this.updateList())
      .then(() => (this.workItemTaskForClose = ''))
      .then(() => this.updateList())
      .then(() => this.updateChildrenList())
      .catch((error: any) => {
        console.error('Error closing work item:', error);
      });
  }

  updateColumn(parsed: any) {
    WorkItemOptionListService.getColumnSaved(this.headers, parsed);
  }

  clearList(query: any) {
    this.workItemFilter = new WorkItemFilter();
    this.paginationChanged();
  }

  clearDates() {
    this.workItemFilter.registerStartDate = '';
    this.workItemFilter.registerEndDate = '';
    this.workItemFilter.estimatedStartDate = '';
    this.workItemFilter.estimatedEndDate = '';
    this.workItemFilter.concludedStartDate = '';
    this.workItemFilter.concludedEndDate = '';
    this.workItemFilter.originCreatedStartDate = '';
    this.workItemFilter.originCreatedEndDate = '';
  }

  changeCreatedStartDate(date: string) {
    this.workItemFilter.registerStartDate = new Date(date).toJSON();
  }

  changeCreatedEndDate(date: string) {
    this.workItemFilter.registerEndDate = new Date(date).toJSON();
  }

  changeEstimatedStartDate(date: string) {
    this.workItemFilter.estimatedStartDate = new Date(date).toJSON();
  }

  changeEstimatedEndDate(date: string) {
    this.workItemFilter.estimatedEndDate = new Date(date).toJSON();
  }

  changeConcludedStartDate(date: string) {
    this.workItemFilter.concludedStartDate = new Date(date).toJSON();
  }

  changeConcludedEndDate(date: string) {
    this.workItemFilter.concludedEndDate = new Date(date).toJSON();
  }

  changeOriginCreatedStartDate(date: string) {
    this.workItemFilter.originCreatedStartDate = new Date(date).toJSON();
  }

  changeOriginCreatedEndDate(date: string) {
    this.workItemFilter.originCreatedEndDate = new Date(date).toJSON();
  }

  searchMembers(projectId: string) {
    UserService
      .searchAllUsersByProject(projectId)
      .then(users => this.filterFields.members = users);
  }

  get filter() {
    return this.workItems;
  }

  filteredWorkItems(workItems: WorkItemSummary[]) {
    return workItems.filter(
      workItem => StringMatch.match(workItem.title, this.filterInput)
        || StringMatch.match(
          workItem.workItemType.name,
          this.filterInput,
        )
        || StringMatch.match(
          workItem.workItemNumber.toString(),
          this.filterInput,
        ),
    );
  }

  sortByMemberName(workItems: WorkItemSummary[]) {
    if (this.selectedMember) {
      return workItems.filter(
        workItem => StringMatch.match(workItem.createdBy, this.selectedMember)
          || StringMatch.match(workItem.assignedTo.userName, this.selectedMember),
      );
    }
    return workItems;
  }

  showModal(workItem: any, action: string, type: string): void {
    this.workItemSelected = workItem;
    this.workItemTypeSelected = type;
    this.workItemAction = action;
    this.modalFields = this.getModalState(workItem, action, type);
    this.dialog = true;
    const isVsts = this.workItemSelected.originSystem === 'VSTS';

    if (isVsts) {
      this.getAllChidrenErrorsByTitleFromWorkItemSelected();
      return;
    }

    this.getAllChidrenErrorsByIdFromWorkItemSelected();
  }

  getAllChidrenErrorsByIdFromWorkItemSelected() {
    if (this.workItemSelected && this.workItemSelected.children) {
      this.workItemSelected.children.forEach((child: WorkItemRelated) => {
        WorkItemService.getWorkItemErrors(this.projectDetail.id, child.id)
          .then(({ data }: any) => {
            child.error = data.error;
          }).catch(() => { });
      });
    }
  }

  getAllChidrenErrorsByTitleFromWorkItemSelected() {
    if (this.workItemSelected && this.workItemSelected.children) {
      this.workItemSelected.children.forEach((child: WorkItemRelated) => {
        WorkItemService
          .getWorkItemErrorsByTitle(this.projectDetail.id, child.title)
          .then(({ data }: any) => {
            child.error = data.error;
          }).catch(() => { });
      });
    }
  }

  getModalState(workItem: WorkItemSummary, action: string, type: string): WorkItemModalState {
    if (workItem.status === 'DONE' && workItem.originSystem === 'VSTS') {
      return WorkItemModalState.ofVstsWorkItem(action, type);
    }
    return WorkItemModalState.of(action, type);
  }

  closeModal() {
    this.dialog = false;
  }

  showModalExport() {
    this.modalExport = true;
  }

  showModalReprocess() {
    this.modalReprocess = true;
  }

  closeModalExportAndReprocess(event: string) {
    if (event === 'modalExport') {
      this.modalExport = false;
    }
    if (event === 'modalReprocess') {
      this.modalReprocess = false;
    }
  }

  addNewTaskWithAggregator(objWorkItem: WorkItemSummary, autoFill: boolean) {
    this.autoFill = autoFill;
    if (autoFill) {
      this.addNewTaskWithAutoFill(objWorkItem);
      return;
    }
    const definitionType = WorkItemDefinitionType.TASK;
    this.workItemTypeSelected = definitionType;
    const object = {
      project: {
        id: this.project.id,
        name: this.$route.params.projectName,
      },
      parent: this.parentWorkItems.find(it => it.id === objWorkItem.id),
      createdDate: this.newDate.toISOString().split('T')[0],
      status: 'OPEN',
      children: [],
    };

    const workItem = WorkItemPostTask.of(object);

    this.showModal(workItem, WorkItemModalActions.CREATE, definitionType);
    this.modalFields.workItemType = false;
  }

  addNewTaskWithAutoFill(objWorkItem: WorkItemSummary) {
    const definitionType = WorkItemDefinitionType.TASK;
    this.workItemTypeSelected = definitionType;
    const object = {
      project: {
        id: this.project.id,
        name: this.$route.params.projectName,
      },
      parent: this.parentWorkItems.find(it => it.id === objWorkItem.id),
      title: objWorkItem.title,
      description: objWorkItem.description,
      assignedTo: [objWorkItem.assignedTo],
      estimatedDeadLine: objWorkItem.estimatedDeadLine,
      originalEstimate: objWorkItem.originalEstimate,
      createdDate: this.newDate.toISOString().split('T')[0],
      status: 'OPEN',
      children: [],
    };

    const workItem = WorkItemPostTask.of(object);

    this.showModal(workItem, WorkItemModalActions.CREATE, definitionType);
    this.modalFields.workItemType = false;
  }

  removeWorkItem(workItem: WorkItemSummary) {
    this.selectedWorkItens = this.selectedWorkItens.filter(item => item.id !== workItem.id);
  }

  clearSelectedWorkItens() {
    this.selectedWorkItens = [];
  }
}
